import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useSnapshot } from "valtio";
import { setIsAddCity, setIsAddZone } from "../store";
import {
    store as device,
    setActions,
    setIsActionsClicked,
    setIsEdited,
    setActiveSubTab,
} from "../GeneralConfigC&C/City/store";
import {
    templateStore,
    templateActions,
} from "@pages/Applications/C&C/C&CSetup/templateStore";
import "./index.css";
import { getTabs } from "./hooks";
import { useSelector } from "react-redux";
interface ModalContentWrapperProps {
    selectedRows: any;
}
export function ModalContentWrapper({
    selectedRows,
}: ModalContentWrapperProps): JSX.Element {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const { isActionsClicked, isEdited, activeSubTab } = useSnapshot(device);
    const { template, isLoading } = useSnapshot(templateStore);
    const [activeTab, setActiveTab] = React.useState<number>(0);
    const [openSubmenuTab, setOpenSubmenuTab] = React.useState<number | null>(
        0
    );
    const tabs = getTabs({ selectedRows, isLoading, template, t });

    function handleTabClick(index: number) {
        if (isEdited) {
            setIsActionsClicked(!isActionsClicked);
            setActions(() => {
                setIsEdited(false);
                setIsAddCity(false);
                setIsAddZone(false);
                performTabChange(index);
            });
        } else {
            performTabChange(index);
            setIsAddCity(false);
            setIsAddZone(false);
        }
    }

    const performTabChange = (index: number) => {
        const clickedTabHasSubmenu = tabs[index].subMenu;

        if (activeTab !== index) {
            setActiveTab(index);
            if (clickedTabHasSubmenu) {
                setOpenSubmenuTab(index);
                setActiveSubTab(0);
            } else {
                setOpenSubmenuTab(null);
            }
        } else if (clickedTabHasSubmenu) {
            setOpenSubmenuTab(index);
        }
    };

    const handleSubmenuClick = React.useCallback((subMenuIndex: number) => {
        setActiveSubTab(subMenuIndex);
    }, []);

    React.useEffect(() => {
        templateActions.setLoading(true);
        fetch(
            `${process.env.REACT_APP_C_AND_C}/Setting/getApkTemplate/${selectedRows[0].iuudApk}`
        )
            .then((res) => res.json())
            .then((result) => {
                templateActions.setTemplate(
                    Object.keys(result.template).length > 0
                        ? result.template
                        : template,
                    result.DateModification,
                    selectedRows[0].iuudApk
                );
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                templateActions.setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRows]);
    return (
        <div
            className="d-grid__clz h-100"
            style={{ gridTemplateColumns: "220px 1fr" }}
        >
            <Nav
                tabs
                className="d-flex flex-column"
                style={{ backgroundColor: mainColor }}
            >
                {tabs.map((tab, index) => (
                    <NavItem
                        key={index}
                        className={classNames("pb-1", tab.customClassName)}
                    >
                        <NavLink
                            className={classNames(
                                "border-0 menu-wrapper-nav-link__clz",
                                {
                                    "active active__clz": activeTab === index,
                                }
                            )}
                            onClick={() => handleTabClick(index)}
                        >
                            <span className="px-2">{tab.title}</span>
                        </NavLink>
                        {openSubmenuTab === index &&
                            tab.subMenu?.map((subTab, subMenuIndex) => (
                                <NavLink
                                    key={subMenuIndex}
                                    className={classNames(
                                        "border-0 text-nowrap pl-5 menu-wrapper-nav-link__clz",
                                        {
                                            "active sub-menu-wrapper-items-nav-link-active__clz":
                                                activeSubTab === subMenuIndex,
                                        }
                                    )}
                                    onClick={() =>
                                        handleSubmenuClick(subMenuIndex)
                                    }
                                >
                                    <span>{subTab.title}</span>
                                </NavLink>
                            ))}
                    </NavItem>
                ))}
            </Nav>

            <TabContent
                activeTab={activeTab}
                style={{
                    overflow: "hidden",
                    overflowY: "auto",
                    position: "revert",
                }}
            >
                {tabs.map((tab, index) => {
                    if (tab.subMenu && openSubmenuTab === index) {
                        return tab.subMenu.map(({ content }, subMenuIndex) => (
                            <TabPane
                                tabId={index}
                                className={classNames({
                                    "d-none": subMenuIndex !== activeSubTab,
                                })}
                                style={{
                                    height: "100%",
                                    width: "100%",
                                    overflow: "hidden",
                                }}
                                key={subMenuIndex}
                            >
                                {content}
                            </TabPane>
                        ));
                    }
                    return (
                        <TabPane
                            tabId={index}
                            key={index}
                            className={classNames("h-100", {
                                "design-active-tab__clz": activeTab === 3,
                            })}
                        >
                            {tab.content}
                        </TabPane>
                    );
                })}
            </TabContent>
        </div>
    );
}
